import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import {
  AlertWarningModule,
  ButtonModule,
  FormAlertModule,
  InputModule
} from '@com-delta-idp/mnx-ui-kit';
import { LoginHeaderModule } from '../../shared/login-header/login-header.module';
import { LogoHeaderModule } from '../../shared/logo-header/logo-header.module';
import { AddEmailAddressComponent } from './add-email-address.component';

@NgModule({
  declarations: [AddEmailAddressComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LogoHeaderModule,
    ButtonModule,
    InputModule,
    AlertWarningModule,
    FormAlertModule,
    LoginHeaderModule
  ],
  exports: [AddEmailAddressComponent, LoginHeaderModule, LogoHeaderModule],
  providers: [FormGroupDirective]
})
export class AddEmailAddressModule {}
